/* eslint-disable no-unreachable */
/* eslint-disable max-nested-callbacks */
/* eslint-disable max-depth */
/* eslint-disable max-depth */
/* eslint-disable camelcase */
// Include Both Helper File with needed methods
import { APIClient } from '../../../helpers/api_helper';
import { loginSuccess, apiError, resetLoginFlaag, setloginloader, logoutUserSuccess } from './reducer';
import { getLoginUserMenuRoutes } from '../../../Components/Common/Util';
import * as url from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import toastMessages from 'Components/Common/messages/toastMessages';
import { ADMIN_LOGIN } from 'fakeResponses/fakeResponse';

const api = new APIClient(process.env.REACT_APP_API_URL || '');

export const loginUser = (user: any, history: any, navData: any) => async (dispatch: any) => {
    try {
        dispatch(setloginloader({ loading: true }));

        // Call login API
        const response = await api.loginMethod(url.USER_LOGIN, user?.email, user?.password);

        const isSuccess = response?.status?.toLowerCase() === 'success';

        if (!isSuccess) {
            throw new Error(response?.message || 'Login failed');
        }

        dispatch(loginSuccess(response.data));

        const roles: any = response?.data?.userProfile?.roles;
        const hasMultipleRoles = roles.length > 1;

        if (hasMultipleRoles) {
            history('/choose-role');
        } else {
            const rolePrivileges = roles[0]?.privileges || [];
            const menuRoutes = getLoginUserMenuRoutes(rolePrivileges, navData);

            const firstRoute = menuRoutes?.[0]?.subItems?.[0]?.link || menuRoutes?.[0]?.link;
            history(firstRoute);
        }

        toast.success(toastMessages.login);
    } catch (error: any) {
        localStorage.clear();
        sessionStorage.clear();
        dispatch(logoutUserSuccess(true));
        dispatch(setloginloader({ loading: false }));
        dispatch(apiError(error?.response || error));
    } finally {
        dispatch(setloginloader({ loading: false }));
    }
};

export const logoutUser = () => async (dispatch: any) => {
    try {
        sessionStorage.clear();
        localStorage.clear();
        dispatch(logoutUserSuccess(true));
    } catch (error) {
        dispatch(apiError(error));
    }
};

export const resetLoginFlag = () => async (dispatch: any) => {
    try {
        const response = dispatch(resetLoginFlaag());
        return response;
    } catch (error) {
        dispatch(apiError(error));
    }
};
